// Incrementa este valor al publicar una nueva versión de la aplicación.
export const APP_VERSION = "1.1.3";

// En desarrollo usa la misma API local que Dalibith-BackOffice. Se emplea HTTP
// para que el navegador no dependa del certificado HTTPS de desarrollo. En
// producción REACT_APP_API_URL es obligatorio: nunca se intenta usar localhost.
const LOCAL_API_URL = "http://localhost:5206/api";
export const API_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "production" ? null : LOCAL_API_URL);
